// extracted by mini-css-extract-plugin
export default {"wrap":"Modals_wrap__b0jVQ","wrapVideo":"Modals_wrapVideo__PlRPs","title":"Modals_title__l2Vdb","text":"Modals_text__w+EHY"};